import { Box, Typography } from '@mui/material';
import StepperParamContainer from 'containers/StepperParamContainer';
import { useTranslation } from 'react-i18next';

export default function TopSectionRegisterPage() {
  const { t } = useTranslation();
  return (
    <>
      <Box>
        <Typography variant="h5">{t('step1.title')}</Typography>
      </Box>
      <Box sx={{ maxWidth: 500, my: 0.5 }}>
        <Typography style={{ whiteSpace: 'pre-line' }} variant="body3">
          {t('step1.desc')}
        </Typography>
      </Box>
      <Box sx={{ maxWidth: 350 }}>
        <StepperParamContainer />
      </Box>
    </>
  );
}
